import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Permissions, RolesEnum, UserQueries } from '@campus/dal';
import { combineLatest, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { PermissionService } from '@campus/shared';
import { Store } from '@ngrx/store';

@Injectable()
export class HomePageGuard implements CanActivate {
  constructor(private router: Router, private permissionService: PermissionService, private store: Store) {}

  canActivate(): Observable<UrlTree | boolean> | Promise<boolean> | boolean {
    return combineLatest([
      this.permissionService.hasPermission$(Permissions.feature.DASHBOARD),
      this.permissionService.hasPermission$(Permissions.settings.APP_SHELL_V2),
      this.store.select(UserQueries.getCurrentUser).pipe(take(1)),
    ]).pipe(
      map(([hasPermission, v2Permission, currentUser]) => {
        if (currentUser.types.some((type) => type === RolesEnum.Schooladmin)) {
          const url = ['schools'];
          if (v2Permission) {
            url.unshift('v2');
          }
          return this.router.createUrlTree(url);
        }

        return hasPermission || this.redirectToMethods();
      })
    );
  }

  private redirectToMethods() {
    return this.router.createUrlTree(['/methods']);
  }
}
